<template>
  <div class="card filtro-periodo-inicio">
    <div class="card-body py-2">
      <div class="row align-items-center">
        <div class="col-md-3 col-4">
          <a
            ref="botaoFiltro"
            class="btn btn-light mb-0"
            data-toggle="collapse"
            href="#collapseFiltroPeriodoInicio"
            role="button"
            aria-expanded="false"
            aria-controls="collapseFiltroPeriodoInicio"
          >
            <i class="text-muted fas fa-stream mr-2"></i>
            Filtro
          </a>
        </div>
        <div class="col-md-6 col-8 text-center periodo-aplicado">
          <i class="far fa-calendar-alt mr-2"></i>
          <strong>Período aplicado:</strong> {{ descricaoPeriodo }}
          <span
            v-if="carregando"
            class="spinner-border spinner-border-sm ml-2"
            role="status"
            aria-label="Carregando dados do período"
          ></span>
        </div>
      </div>

      <div id="collapseFiltroPeriodoInicio" class="collapse">
        <form class="row justify-content-center align-items-end pt-3" @submit.prevent="aplicar">
          <div class="col-lg-3 col-md-4 col-sm-5 mb-2">
            <label for="filtroInicioDataInicial" 
              style="font-size: 13px; margin-left: 5px;"
              class="mb-1 font-weight-bold">Data inicial</label>
            <flat-picker
              id="filtroInicioDataInicial"
              v-model="dataInicio"
              class="form-control datepicker"
              placeholder="Data inicial"
              autocomplete="off"
              :disabled="carregando"
              :config="configData"
            />
          </div>
          <div class="col-lg-3 col-md-4 col-sm-5 mb-2">
            <label for="filtroInicioDataFinal" 
              style="font-size: 13px; margin-left: 5px;"
              class="mb-1 font-weight-bold">Data final</label>
            <flat-picker
              id="filtroInicioDataFinal"
              v-model="dataFim"
              class="form-control datepicker"
              placeholder="Data final"
              autocomplete="off"
              :disabled="carregando"
              :config="configData"
            />
          </div>
          <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
            <button type="submit" class="btn btn-info btn-block" :disabled="carregando">
              <span v-if="carregando" class="spinner-border spinner-border-sm mr-2" role="status"></span>
              <i v-else class="fas fa-filter mr-2"></i>
              {{ carregando ? "Carregando" : "Aplicar" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "FiltroPeriodoInicio",
  components: {
    flatPicker,
  },
  props: {
    periodo: {
      type: Object,
      required: true,
    },
    carregando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataInicio: "",
      dataFim: "",
      configData: {
        allowInput: true,
        dateFormat: "d/m/Y",
      },
    };
  },
  computed: {
    descricaoPeriodo() {
      if (this.periodo.dataInicio && this.periodo.dataFim) {
        return `${this.periodo.dataInicio} a ${this.periodo.dataFim}`;
      }
      if (this.periodo.dataInicio) return `a partir de ${this.periodo.dataInicio}`;
      if (this.periodo.dataFim) return `até ${this.periodo.dataFim}`;
      return "todo o período";
    },
  },
  watch: {
    periodo: {
      immediate: true,
      deep: true,
      handler(periodo) {
        this.dataInicio = periodo.dataInicio || "";
        this.dataFim = periodo.dataFim || "";
      },
    },
  },
  methods: {
    aplicar() {
      if (!this.dataValida(this.dataInicio) || !this.dataValida(this.dataFim)) {
        this.$toastr.error("Informe as datas no formato dd/mm/aaaa.");
        return;
      }
      if (this.dataInicio && this.dataFim
          && this.converterData(this.dataInicio) > this.converterData(this.dataFim)) {
        this.$toastr.error("A data inicial não pode ser posterior à data final.");
        return;
      }
      this.$refs.botaoFiltro.click();
      this.$emit("aplicar", {
        dataInicio: this.dataInicio || "",
        dataFim: this.dataFim || "",
      });
    },
    dataValida(valor) {
      if (!valor) return true;
      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) return false;
      const partes = valor.split("/").map(Number);
      const data = new Date(partes[2], partes[1] - 1, partes[0]);
      return data.getFullYear() === partes[2]
        && data.getMonth() === partes[1] - 1
        && data.getDate() === partes[0];
    },
    converterData(valor) {
      const partes = valor.split("/").map(Number);
      return new Date(partes[2], partes[1] - 1, partes[0]).getTime();
    },
  },
};
</script>

<style scoped>
.filtro-periodo-inicio {
  margin: 8px 12px 2px;
}

.periodo-aplicado {
  color: #465675;
  font-size: 13px;
}

@media (min-width: 992px) {
  .campo-data-periodo {
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
}

@media (max-width: 767px) {
  .periodo-aplicado {
    text-align: right !important;
  }
}
</style>
